module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"replay":"REPLAY","back":"Back"},"es":{"replay":"Volver a reproducir","back":"Atrás"},"pt":{"replay":"Reproduzir","back":"Voltar"}}')
  delete Component.options._Ctor
}
